<script>
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "@/firebase";
import axios from "axios";
import { statusBadgeClass, formatDate } from '@/components/utils.js'
import OperationsTable from "./OperationsTable.vue";
export default {
    components: {
        OperationsTable
    },
    data() {
        return {
            log: null,
            currentPage: 1,
            errorsPerPage: 10,
            translations: {
                LogActionsEnum: {},
                JobLogStatus: {}
            },
        };
    },
    props: {
        tenant: null,
        locale: null,
        id: null
    },
    async mounted() {
        this.$i18n.locale = this.locale;
        await this.fetchMarketplaces();
        // TODO: remove
		  // await this.$store.dispatch('Chat/authenticateWithFirebase');
        const logId = this.id; // Get the ID from the route parameter
        const docRef = doc(db, `tenants/${this.tenant}/logs`, logId);
        const docSnap = await getDoc(docRef);

        this.fetchTranslations();
        if (docSnap.exists()) {
            this.log = { id: docSnap.id, ...docSnap.data() };
            await this.fetchErrors(); // Fetch errors after setting log
        } else {
            console.log("No such document!");
        }
    },
    computed: {
        paginatedErrors() {
            if (!this.log || !Array.isArray(this.log.errors)) return [];
            const start = (this.currentPage - 1) * this.errorsPerPage;
            const end = start + this.errorsPerPage;
            return this.log.errors.slice(start, end);
        },
        totalPages() {
            if (!this.log || !Array.isArray(this.log.errors)) return 0;
            return Math.ceil(this.log.errors.length / this.errorsPerPage);
        },
        pagesOptions() {
			if (this.log?.errors?.length == 0) return [];
			const PAGES_RANGE = 1;
			const result = [];
			const selectedPage = this.currentPage;

			for (let i = Math.max(1, selectedPage - PAGES_RANGE); i < selectedPage; i++) {
				result.push(i);
			}
			result.push(selectedPage);
			for (
				let i = selectedPage + 1;
				i <= Math.min(this.totalPages, selectedPage + PAGES_RANGE);
				i++
			) {
				result.push(i);
			}

			return result;
		},
    },
    methods: {
        statusBadgeClass,
        formatDate,
        async fetchMarketplaces() {
            try {
                const response = await axios.get(`${window.location.origin}/api/v1/linked-marketplaces`);
                this.marketplaces = response.data?.result?.linked_marketplaces?.data;
            } catch (error) {
                console.error("Error fetching marketplaces:", error);
            }
        },
        findMarketplaceById(marketplaceId) {
            return this.marketplaces?.find(marketplace => marketplace?.marketplace_id === marketplaceId) || null;
        },
        async fetchTranslations() {
            // Example API call to fetch translations
            const response = await axios.get('/core/list/enum-list?list[]=LogActionsEnum&list[]=JobLogStatus');
            if (response.data && response.data.result && response.data.result.lists) {
                this.translations = response.data.result.lists;
            }
        },
        async fetchErrors() {
            const errorsCollectionRef = collection(db, `tenants/${this.tenant}/logs/${this.id}/errors`);
            const querySnapshot = await getDocs(errorsCollectionRef);
            const errors = querySnapshot.docs.map(doc => doc.data()); // This creates an array of error objects
            // Directly assign the errors array to this.log.errors
            this.log.errors = errors[0]?.errors || [];
        },
        translateLogName(logName) {
            return this.translations.LogActionsEnum[logName] || logName;
        },
        translateStatus(status) {
            return this.translations.JobLogStatus[status] || status;
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        goToPage(pageNumber) {
            if (pageNumber >= 1 && pageNumber <= this.totalPages) {
                this.currentPage = pageNumber;
            }
        },
    }
};

</script>
<template>
    <div id="kt_content_container" class="d-flex flex-column-fluid align-items-start container-xxl" v-if="log">
        <div class="content flex-row-fluid" id="kt_content">
            <div class="page-title d-flex py-5 flex-column me-3"><!--begin::Title-->
                <h1 class="text-white text-bolder">{{ $t('operation_details') }}</h1>
            </div><!--end::Page title--><!--begin::Actions-->
            <div class="row">
                <div class="col-md-8 my-2">
                    <OperationsTable :tenant="tenant" :locale="locale" :id="id" />
                    <div class="card  px-3 mt-4">
                        <div class="card-title">
                            <h3 class="p-2 pt-3 pb-0">
                                {{ $t('errors') }} ({{log?.errors_count}})
                            </h3>
                        </div>
                        <table class="vue-tables border border-secondary rounded-lg">
                            <thead>
                                <tr class="bg-secondary">
                                    <th class="px-5 py-3">{{ $t("name") }}</th>
                                    <!-- <th class="px-5">{{ $t("stage") }}</th> -->
                                    <th class="px-5 py-3">{{ $t("Error Message") }}</th>
                                </tr>
                            </thead>
                            <!-- {{ log?.errors }} -->
                            <tbody>
                                <tr v-if="paginatedErrors.length === 0">
                                    <td colspan="2" class="text-center">{{ $t("No Errors") }}</td>
                                </tr>
                                <tr v-else v-for="(error, index) in paginatedErrors" :key="index"
                                    class="border border-secondary">
                                    <td class="px-5">{{ error?.name }}</td>
                                    <!-- <td class="px-5">{{ error?.stage }}</td> -->
                                    <td class="px-5">{{ error?.message }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="pagination-controls">
		                	<button @click="prevPage" :disabled="currentPage <= 1">{{ $t('previous') }}</button>
		                	<template v-if="pagesOptions.length > 0 && pagesOptions[0] !== 1 && totalPages > 0">
		                		<button @click="goToPage(1)">
		                			{{ 1 }}
		                		</button>
		                		<span class="px-1 pt-2">...</span>
		                	</template>
		                	<span v-for="n in pagesOptions" :key="n">
		                		<button
		                			@click="goToPage(n)"
		                			:disabled="currentPage === n"
		                			:class="{ active: currentPage === n }"
		                		>
		                			{{ n }}
		                		</button>
		                	</span>
		                	<template
		                		v-if="pagesOptions.length > 0 && pagesOptions[pagesOptions.length - 1] !== totalPages && totalPages > 0"
		                	>
		                		<span class="px-1 pt-2">...</span>
                                <button @click="goToPage(totalPages)">
		                			{{ totalPages }}
		                		</button>
		                	</template>
		                	<button @click="nextPage" :disabled="currentPage >= totalPages">{{ $t('next') }}</button>
		                </div>
                    </div>
                </div>
                <div class="col-md-4 my-2">

                    <div class="card ">
                        <div class="card-header mt-5">
                            <div class="card-title flex-column">
                                <h4>{{$t('operation_information')}} </h4>
                                <span class="font-weight-bolder ltr fs-7 mt-2 fw-light" v-html="formatDate(log?.created_at) "></span>
                            </div>
                        </div>
                        <div class="card-body py-4 ">
                            <div class="d-flex justify-content-between py-4">
                                <strong class="font-weight-bolder">{{$t('operation')}}</strong>
                                <span class="font-weight-bolder ltr">{{ translateLogName(log.logName) }}</span>
                            </div>
                            <div class="d-flex justify-content-between py-4">
                                <strong class="font-weight-bolder">{{$t('marketplace')}}</strong>
                                <span class="font-weight-bolder"><img v-if="log.options?.marketplace_id" class="w-30px" :src="findMarketplaceById(log.options?.marketplace_id)?.marketplace?.logo_url || 'assets/image/linker_placeholder.png'" :alt="translateLogName(log.logName)"></span>
                            </div>
                            <div class="d-flex justify-content-between py-4">
                                <strong class="font-weight-bolder">{{ $t('operations') }}</strong>
                                <span class="font-weight-bolder">{{log?.rows_count || 0}}</span>
                            </div>
                            <div class="d-flex justify-content-between py-4">
                                <strong class="font-weight-bolder">{{ $t('errors') }}</strong>
                                <span class="font-weight-bolder">{{log?.errors_count}}</span>
                            </div>
                            <div class="d-flex justify-content-between py-4">
                                <strong class="font-weight-bolder">{{$t('status')}}</strong>
                                <span class="font-weight-bolder">
                                    <span :class="statusBadgeClass(log?.status)">
                                        {{ translateStatus(log?.status) }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
@import "../styles/index.scss";
</style>
